import { useState } from "react";
import Switch from "../../../components/switch/Switch";
import { useMutation, useQueryClient } from "react-query";
import { setPlantState } from "../../../api/plantManagement";
import { CardProps } from "../../../interfaces";
import NavgigationLink from "../../../components/link/NavgigationLink";
import { ROUTE_PATH } from "../../../contants/routePath";
import ExternalLink from "../../../components/link/ExternalLink";

const Card = ({ name, code, isSelected, id }: CardProps) => {
  const [plantIsEnabled, setPlantEnabled] = useState<boolean>(isSelected);
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (plantState: any) => {
      return setPlantState(plantState);
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ["activePlants"] });
    },
  });

  const handleToggle = () => {
    let newState;
    setPlantEnabled((prev) => {
      newState = !prev;
      return newState;
    });
    mutation.mutate({ location: code, enabled: newState });
  };

  return (
    <div className="bg-white w-72  p-3 rounded-3xl" key={id}>
      <div className="flex justify-between items-center">
        <div>
          <span className="text-tertiaryText">{name}</span>
          <h2 className="m-0 text-secondaryText font-medium">{code}</h2>
        </div>
        <div className="flex gap-3">
          <span>{}</span>
          <Switch isSelected={plantIsEnabled} onClick={handleToggle} />
        </div>
      </div>
      <div className="flex justify-between mt-10">
        <ExternalLink
          href={`${ROUTE_PATH.lgv}/${code}/preview`}
          target="_blank"
        >
          Preview
        </ExternalLink>
        <NavgigationLink to={`plants/${code}/bound-adjustment`}>
          Edit
        </NavgigationLink>
      </div>
    </div>
  );
};

export default Card;
